import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { updateBusinessTypeAndCurrency } from '../bridge';
import { useAuth } from '../context/AuthContext';
import '../styles/Auth.css';

const logo = require('../logo.jpeg');

const BUSINESS_TYPES = [
  { label: 'Restaurant', icon: '🍽️' },
  { label: 'Store', icon: '🛍️' },
  { label: 'Service Provider', icon: '🔧' },
  { label: 'Other', icon: '💼' },
];

const CURRENCIES = [
  { label: 'US Dollar', symbol: '$' },
  { label: 'Euro', symbol: '€' },
  { label: 'British Pound', symbol: '£' },
  { label: 'Brazilian Real', symbol: 'R$' },
];

const AccountType = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { login } = useAuth();
  const email = state?.email || '';

  const [businessType, setBusinessType] = useState('');
  const [currency, setCurrency] = useState('$');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!businessType) {
      setError('Please select your business type.');
      return;
    }
    setLoading(true);
    const ok = await updateBusinessTypeAndCurrency(email, businessType, currency);
    setLoading(false);
    if (!ok) {
      setError('Something went wrong. Please try again.');
      return;
    }
    login(email);
    navigate('/manage', { replace: true });
  };

  return (
    <div className="auth-page">
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-brand">
            <img src={logo} className="navbar-logo" alt="Menu & Catalog Maker" />
            <span className="navbar-title">Menu &amp; Catalog Maker</span>
          </Link>
        </div>
      </nav>

      <div className="auth-body">
        <div className="auth-card">
          <h1 className="auth-card-title">Set up your business</h1>
          <p className="auth-card-subtitle">
            Choose your business type and the currency you use for your products.
          </p>

          {error && <div className="auth-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="auth-label" style={{ marginBottom: 12 }}>Business type</div>
            <div className="auth-option-grid">
              {BUSINESS_TYPES.map(({ label, icon }) => (
                <button
                  key={label}
                  type="button"
                  className={`auth-option-btn${businessType === label ? ' selected' : ''}`}
                  onClick={() => setBusinessType(label)}
                >
                  <span className="auth-option-icon">{icon}</span>
                  <span className="auth-option-label">{label}</span>
                </button>
              ))}
            </div>

            <div className="auth-field">
              <label className="auth-label">Currency</label>
              <select
                className="auth-select"
                value={currency}
                onChange={e => setCurrency(e.target.value)}
              >
                {CURRENCIES.map(({ label, symbol }) => (
                  <option key={symbol} value={symbol}>
                    {symbol} — {label}
                  </option>
                ))}
              </select>
            </div>

            <button className="auth-submit" type="submit" disabled={loading || !businessType}>
              {loading ? 'Saving…' : 'Go to my dashboard'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AccountType;
